module.exports = __webpack_public_path__ + "static/media/oedipoda_caerulescens_001_APA.b0cbff89.png";